// extracted by mini-css-extract-plugin
module.exports = {"mainTitle":"MainTitle_mainTitle__Kr1l_","mainTitle--light":"MainTitle_mainTitle--light__Kzymd"};